import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ums",
  "use": "icon-ums-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-ums\">\n<path d=\"M3,16.2C3,16.6,3.4,17,3.8,17h12.5c0.4,0,0.7-0.3,0.7-0.7V7.4H3V16.2z M10.5,8.9c0.5-0.5,1.2-0.5,1.2-0.5l0.1,0.4l-0.7,0.8\n\tl1.1,1.1L13,9.9l0.4,0.1c0,0,0,0.8-0.5,1.2c-0.5,0.4-1.2,0.5-1.9,0.2l-0.4,0.4l-0.7-0.7l0.4-0.3C9.9,10.1,10,9.4,10.5,8.9z M7.3,9.5\n\tl0.2-0.2l0.9,0.5l0,0.6l2.2,2.2l0.4-0.4l2.1,2.1c-0.3,0.7-0.7,1.1-1.4,1.3c-0.7-0.7-1.4-1.4-2.1-2.1l0.5-0.5l-2.3-2.3l-0.6,0L6.8,10\n\tC6.8,10,7.3,9.5,7.3,9.5z M6.7,14.3l2-1.9l0.8,0.8l-1.9,2.1c0,0-0.4,0-0.6-0.2C6.7,14.8,6.7,14.3,6.7,14.3z M16.2,3H3.8\n\tC3.4,3,3,3.4,3,3.8v2.6H17V3.8C17,3.4,16.6,3,16.2,3z M6.5,5.2H5.1C4.8,5.2,4.5,5,4.5,4.7c0-0.3,0.3-0.5,0.5-0.5h1.5\n\tc0.3,0,0.5,0.3,0.5,0.5C7.1,5,6.8,5.2,6.5,5.2z M14.9,5.2H9.1C8.8,5.2,8.5,5,8.5,4.7c0-0.3,0.3-0.5,0.5-0.5h5.9\n\tc0.3,0,0.5,0.3,0.5,0.5C15.5,5,15.2,5.2,14.9,5.2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ums.svg
// module id = J4x9
// module chunks = 97